import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { get, patch } from "../helpers/config";

export const useGetAppConfigurations = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation({
        mutationFn: async () => {
            return await get("appconfiguration/get", true);
        },
        ...options
    });
};

export const useUpdateAppConfigurations = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation({
        mutationFn: async (data: any) => {
            return await patch("appconfiguration/update", data, true);
        },
        ...options
    });
};